var res = false;

function validate(email){
    var re = /\S+@\S+\.\S+/;
        res = re.test(email)
        return re.test(email);
}
export { validate, res }


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-email-validator/index.js
// module id = 536
// module chunks = 0